import * as types from '../constants/action-types';
import Reviews from '../../../../api/api-reviews';

export function fetchReview (reviewId, accessToken, callback) {
  return dispatch => {
    dispatch({ type: types.REVIEW_FETCH_REQUEST });

    Reviews.read('/' + reviewId, accessToken, (response) => {
      if (response.error) {
        return dispatch({ type: types.REVIEW_FETCH_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.REVIEW_FETCH_SUCCESS,
        payload: response
      });
    });
  };
}

export function updateReview (reviewId, accessToken, payload, callback) {
  return dispatch => {
    dispatch({ type: types.REVIEW_UPDATE_REQUEST });

    Reviews.update(reviewId, accessToken, payload, (response) => {
      if (response.error) {
        return dispatch({ type: types.REVIEW_UPDATE_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.REVIEW_UPDATE_SUCCESS,
        payload: response
      });
    });
  };
}
